import { AlertTriangle } from "lucide-react";

/**
 * ScopeReminderCallout Component
 * 
 * Displays a non-dismissible callout showing what a service does NOT include.
 * Used to set clear expectations and prevent scope creep discussions.
 * 
 * Props:
 * - excludes: Array of exclusion strings
 * - title: Optional custom title (default: "This service does NOT include:")
 */
const ScopeReminderCallout = ({ 
  excludes = [], 
  title = "This service does NOT include:" 
}) => {
  if (!excludes || excludes.length === 0) {
    return null;
  }

  return (
    <div 
      className="border border-amber-500/30 bg-amber-950/20 rounded-lg p-4 mt-4"
      data-testid="scope-reminder-callout"
    >
      <div className="flex items-start gap-3">
        <AlertTriangle className="w-5 h-5 text-amber-500 flex-shrink-0 mt-0.5" />
        <div className="flex-1">
          <h4 className="text-amber-400 font-semibold text-sm mb-2">
            {title}
          </h4>
          <ul className="space-y-1.5">
            {excludes.map((item, index) => (
              <li 
                key={index} 
                className="text-slate-400 text-sm flex items-start gap-2"
              >
                <span className="text-amber-500/70 mt-1">•</span>
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ScopeReminderCallout;
